import React from 'react';
import PropTypes from 'prop-types';
import { Button, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useIsMobile } from '../hooks';

const StickyButtonContainer = ({
  children,
  text,
  onClick,
  disableButton = false,
  offsets,
}) => {
  const classes = useStyles();
  const isMobile = useIsMobile();
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <Box className={classes.container}>
      {!isMobile && (
        <Button
          className={[offsets, classes.printButton, classes.hideOnPrint]}
          color={'primary'}
          variant='contained'
          size='small'
          onClick={handleClick}
          disabled={disableButton}
        >
          {text}
        </Button>
      )}
      {children}
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  hideOnPrint: {
    display: 'block',
    '@media print': {
      display: 'none',
    },
  },
  printButton: {
    opacity: 0.3,
    position: 'absolute',
    left: 10,
    bottom: 10,
    zIndex: 10000,
    '&:hover': {
      opacity: 1,
    },
  },
  printButtonMobile: {
    position: 'absolute',
    left: 10,
    bottom: 10,
    zIndex: 10000,
  },
});

StickyButtonContainer.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disableButton: PropTypes.bool,
  offsets: PropTypes.shape({
    top: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number,
  }),
};

StickyButtonContainer.defaultProps = {
  offsets: {
    bottom: 10,
    left: 10,
  },
};

export default StickyButtonContainer;
